<template>
  <div :class="['w-100', { 'sticky-top': isMobile }]" id="navbar-top-container">
    <b-navbar toggleable="md" type="light" variant="white">
      <div :class="[
        'd-flex align-items-center w-100 justify-content-between',
        { container: !isMobile }
      ]">
        <b-button v-b-toggle.mobile-menu-sidebar id="mobile-navicon"
          :class="['d-inline d-md-none', { open: isMobileNaviconOpen }]" ref="mobileNavIcon" @click.prevent>
          <span :class="{ 'bg-white': subdomain === 'carmens-best' }"></span>
          <span :class="{ 'bg-white': subdomain === 'carmens-best' }"></span>
          <span :class="{ 'bg-white': subdomain === 'carmens-best' }"></span>
          <span :class="{ 'bg-white': subdomain === 'carmens-best' }"></span>
        </b-button>
        <b-navbar-brand href="#" class="text-center text-md-left flex-grow-0">
          <NavBrand />
        </b-navbar-brand>
        <b-navbar-nav id="selected-place-container" class="mr-auto d-none d-md-inline" v-if="isEstoreTopUp">
          <b-nav-item href="#" class="ws-border text-dark" @click="toggleLocations()" id="selectMap">
            <div class="d-flex align-items-center justify-content-center mr-7 flex-shrink-0" :style="{
              backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : '#ff8a00',
              width: webDesign && webDesign.design ? '28px' : '45px',
              height: webDesign && webDesign.design ? '28px' : '45px',
              'border-radius': '50%'
            }">
              <img src="@/assets/images/pin-white.svg" :width="webDesign && webDesign.design ? '15px' : '25px'"
                :height="webDesign && webDesign.design ? '18px' : '25px'" alt="White Pin" />
            </div>
            <span class="mr-1" style="font-size: 14px; color: #2F3941;">Deliver to</span>
            <span class="fw-bold text-truncate" style="font-size: 14px; color: #2F3941; width: 258px;">{{ selectedPlace
              }}</span>
            <img src="@/assets/images/arrow-down.svg" style="height: 18px;" alt="Down Arrow" />
          </b-nav-item>
          <div class="location-search-list" v-bind:class="{ 'd-none': !showLocations }"
            :style="[hasAutocompleteResults ? { 'height': '365px' } : {}]">
            <b-container class="search-input" ondragstart="return false;" ondrop="return false;">
              <b-row>
                <b-col class="fw-bold">
                  Enter Delivery Address
                </b-col>
              </b-row>
              <b-row class="mt-3 px-2">
                <b-col class="position-relative px-1">
                  <gmap-autocomplete placeholder="Your Address" @place_changed="setPlace" class="form-control" :options="{
                    componentRestrictions: { country: 'ph' },
                  }" :disabled="cart && cart.cart_count > 0" ref="address" @click="onLocationAutocomplete"
                    @input="onLocationAutocomplete" @blur="hasAutocompleteResults = false" />
                  <img v-if="location" @click.self="clearAddress" src="@/assets/images/remove-filled.svg"
                    class="cursor-pointer position-absolute" style="top: 8px; right: 40px;" alt="Clear" />
                  <img @click="openMap" src="@/assets/images/map.svg" class="cursor-pointer position-absolute"
                    style="top: 5px; right: 10px;" alt />
                </b-col>
              </b-row>
              <b-button variant="link" @click="getCurrentPosition(true)" class="fw-bold px-0 position-absolute"
                style="font-size: 14px; color: #2F3941; text-decoration: underline; bottom: 30px;">
                Use Current Location
              </b-button>
            </b-container>
          </div>
        </b-navbar-nav>
        <b-navbar-nav id="auth-cart-container" class="d-flex flex-row">
          <b-nav-form id="">
            <div class="search-input d-none">
              <span class="search-input-label mr-25" v-on:click="searchToggle = true" v-if="!searchToggle">
                <img src="@/assets/images/ic-search.svg" style="vertical-align: bottom" class="mr-1" alt="Search" />
                Search
              </span>
              <span class="search-input-field mr-25" v-if="searchToggle">
                <input type="text" class="form-control" />
                <img src="@/assets/images/ic-close.svg" class="search-input-field-close"
                  v-on:click="searchToggle = false" alt="Close" />
              </span>
            </div>
            <span class="search-label-btn"></span>
            <template v-if="!loggedIn">
              <template v-if="subdomain === 'ucoin'">
                <b-button class="btn-core d-none d-md-inline mx-3 text-nowrap" :to="'/' + subdomain + '/login'">SIGN
                  IN</b-button>
              </template>
              <template v-else>
                <b-button class="btn-core d-none d-md-inline mx-3 text-nowrap" :style="{
                  backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
                  border: webDesign && webDesign.design ? 'none !important' : null,
                  color: webDesign && webDesign.design ? `${webDesign.design.button_text_color} !important` : null
                }" :to="'/' + subdomain + '/login'">
                  SIGN IN
                </b-button>
              </template>
            </template>
            <template v-if="loggedIn">
              <b-nav-item-dropdown right no-caret class="profileDropdown d-none d-md-block">
                <template v-slot:button-content>
                  <span class="profile-menu-link ml-20" id="profileDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <template v-if="
                      customer.constructor === Object &&
                      Object.keys(customer).length
                    ">
                      <strong class="text-capitalize mr-1 fw-bold">
                        Hi, {{ customer.firstname }}
                      </strong>
                      <template v-if="
                        !customer.profile_image ||
                        customer.profile_image.includes('default')
                      ">
                        <profile-icon />
                      </template>
                      <template v-else>
                        <img :src="customer.profile_image" alt="Profile" class="profile-image rounded-circle" />
                      </template>
                    </template>
                    <template v-else>
                      <strong class="text-capitalize mr-1 fw-bold">
                        Hi, {{ user.customer.firstname }}
                      </strong>
                      <template v-if="
                        !user.customer.profile_image ||
                        user.customer.profile_image.includes('default')
                      ">
                        <profile-icon />
                      </template>
                      <template v-else>
                        <img :src="user.customer.profile_image" alt="Profile" class="profile-image rounded-circle" />
                      </template>
                    </template>
                    <img src="@/assets/images/arrow-down.svg" alt="Down Arrow" />
                  </span>
                </template>
                <b-dropdown-item :to="{ name: 'Profile' }" exact>
                  <div class="d-flex align-items-center">
                    <div class="mr-10 d-flex align-items-center justify-content-center mr-7" :style="{
                      backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : '#ff8a00',
                      width: webDesign && webDesign.design ? '35px' : '45px',
                      height: webDesign && webDesign.design ? '35px' : '45px',
                      'border-radius': '50%'
                    }">
                      <img src="@/assets/images/person.svg" width="20px" height="18px" alt="profile" />
                    </div>
                    <span>My Profile</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'Orders' }" exact v-if="isEstoreTopUp">
                  <div class="d-flex align-items-center">
                    <div class="mr-10 d-flex align-items-center justify-content-center mr-7" :style="{
                      backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : '#ff8a00',
                      width: webDesign && webDesign.design ? '35px' : '45px',
                      height: webDesign && webDesign.design ? '35px' : '45px',
                      'border-radius': '50%'
                    }">
                      <img src="@/assets/images/shopping-bag.svg" width="20px" height="18px" alt="orders" />
                    </div>
                    <span>My Orders</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'TransactionHistory' }" exact v-if="isPointsView">
                  <div class="d-flex align-items-center">
                    <div class="mr-10 d-flex align-items-center justify-content-center mr-7"
                      v-if="webDesign !== null && webDesign.design !== null" :style="{
                        backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : '#ff8a00',
                        width: webDesign && webDesign.design ? '35px' : '45px',
                        height: webDesign && webDesign.design ? '35px' : '45px',
                        'border-radius': '50%'
                      }">
                      <img src="@/assets/images/ic-transaction-history.svg" width="20px" height="18px" alt="transaction-history" />
                    </div>
                    <span>Transaction History</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'MyPoints' }" exact v-if="subdomain === 'ucoin'">
                  <div class="d-flex">
                    <div class="mr-10 d-flex align-items-center justify-content-center mr-7" :style="{
                        backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : '#ff8a00',
                        width: webDesign && webDesign.design ? '35px' : '45px',
                        height: webDesign && webDesign.design ? '35px' : '45px',
                        'border-radius': '50%'
                      }">
                      <img src="@/assets/images/ic-star-outline.svg" width="20px" height="18px" alt="points" />
                    </div>
                    <span>My Points</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item v-on:click.prevent="logout()" class="mt-10 grey">Sign Out</b-dropdown-item>
              </b-nav-item-dropdown>
              <div 
                class="points-container d-none d-md-flex mr-3 align-items-center px-2" 
                v-if="isPointsView"
              >
                <div class="star-container">
                  <img src="@/assets/images/points-badge.svg" alt="points" />
                </div>
                <div class="balance-container text-nowrap">
                  <span class="fw-bold">{{ putComma(balance) }} </span>
                  <span v-if="balance <= 1">{{
                    subdomain === "ucoin" ? "UCOIN" : "Pt."
                    }}</span>
                  <span v-else style="color: lightgrey">{{
                    subdomain === "ucoin" ? "UCOINS" : "Pts."
                    }}</span>
                </div>
              </div>
            </template>
            <span class="cart-item-count position-relative" v-on:click="
              isMobile && $router.history.current.name !== 'Cart'
                ? handleCartMobile()
                : (cartToggle = !cartToggle)
              " v-if="isEstoreTopUp" :style="{ left: isMobile ? '-7px' : null }">
              <img src="@/assets/images/ic-cart.svg" alt="Cart" />
              <div v-if="webDesign !== null && webDesign.design !== null" class="position-absolute" :style="{
                display: 'inline',
                right: '-15px',
                top: '-10px'
              }">
                <span v-if="cart && cart.cart_count" :style="{
                  backgroundColor:
                    webDesign.design.main_color + '!important',
                  border: 'none !important',
                  color: webDesign.design.button_text_color + '!important'
                }">{{ cart.cart_count }}</span>
              </div>
              <div v-else class="position-absolute" style="display: inline; top: -10px; right: -15px;">
                <span v-if="cart && cart.cart_count">{{ cart.cart_count }}</span>
              </div>
            </span>
          </b-nav-form>
        </b-navbar-nav>
      </div>
      <div class="pos-rlt" v-if="cartToggle">
        <div class="cart-mini flex-column d-md-auto">
          <div class="header">
            <h2 class="d-flex align-items-center justify-content-start justify-content-md-between mb-0">
              <img src="@/assets/images/ic-arrow-left.svg" v-on:click="cartToggle = false"
                class="d-inline d-md-none mr-3" alt="Left Arrow" />
              My Cart
              <img src="@/assets/images/ic-close.svg" v-on:click="cartToggle = false" class="d-none d-md-inline"
                alt="Close" />
            </h2>
            <div class="row position-relative" v-if="cart && cart.cart_count >= 1">
              <div class="col-6 align-content-center">
                <span class="text-muted branch-count" v-if="cart.list.length > 1"> {{ cart.list.length + ' branches'
                  }}</span>
                <span class=" branch-count" v-else>{{ cart.list[0].brand_name }} ({{ cart.list[0].branch_name }})</span>
              </div>
              <div class="col-6 text-right">
                <b-button type="button" class="clear-cart fw-bold" @click="removeAllModal = true" :style="{ color: '#2F3941' }">
                  Clear Cart
                </b-button>
              </div>
              <div class="remove-all-modal" v-show="removeAllModal">
                <label for="remove-all-items">Remove all items?</label>
                <ul>
                  <li @click="$root.$emit('confirmRemoveAllCartItems')">Yes</li>
                  <li @click="removeAllModal = false">No</li>
                </ul>
              </div>
            </div>
          </div>
          <b-overlay :show="estoreIsLoadingOverlay" rounded="sm" style="min-height: 50px">
            <Cart class="flex-grow-1" v-if="cart" source="navbar" />
          </b-overlay>
          <div class="cart-footer pt-3" v-if="cart && cart.cart_count >= 1">
            <button @click="goTo('Cart')" type="button" class="btn btn-core-shallow w-210 fw-bold" :style="{
              padding: '5px !important',
              'border-radius': '33px !important',
              'background-color': 'transparent !important',
              'font-size': '16px !important',
              borderColor: webDesign && webDesign.design ? webDesign.design.main_color : null,
              color: webDesign && webDesign.design ? webDesign.design.main_color : null
            }">
              View Cart
            </button>
            <button @click="goTo('Checkout')" type="button" class="btn btn-core w-210 fw-bold" :style="{
              backgroundColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
              borderColor: webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
              color: webDesign && webDesign.design ? `${webDesign.design.button_text_color} !important` : null,
              padding: '5px !important',
              'border-radius': '33px !important',
              'font-size': '16px !important'
            }">
              Checkout
            </button>
          </div>
        </div>
      </div>
      <template v-if="
        isEstoreTopUp &&
        ($route.name === 'Home' ||
          $route.name === 'Store' ||
          $route.name === 'Cart' ||
          $route.name === 'Checkout' ||
          $route.name === 'OrderDetails')
      ">
        <div :class="{
          container: !isMobile,
          'w-100': isMobile,
          'mobile-location d-none': isEstoreTopUp &&
            ($route.name === 'Home' ||
              $route.name === 'Store' ||
              $route.name === 'Cart' ||
              $route.name === 'Checkout' ||
              $route.name === 'OrderDetails')
        }">
          <b-form-group class="w-100 border px-2" style="border-radius: 50px;">
            <b-input-group class="align-items-center position-relative" @click="onClickMobileLocation">
              <b-input-group-prepend class="d-inline-flex align-items-center justify-content-center rounded-circle m-0"
                :style="{
                  width: '35px',
                  height: '35px',
                  background: webDesign && webDesign.design ? webDesign.design.main_color : 'rgb(255, 138, 0)'
                }">
                <img src="@/assets/images/pin-white.svg" width="25px" height="25px" alt="White Pin" />
              </b-input-group-prepend>
              <b-input type="text" class="border-0 bg-white" :value="selectedPlace" readonly />
              <b-input-group-append v-if="location !== null">
                <img src="@/assets/images/arrow-down.svg"
                  style="transform: rotate(-90deg); height: 20px; filter: contrast(0.5);" alt="Down Arrow" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </template>
    </b-navbar>
    <b-modal ref="location" centered hide-header hide-footer body-class="text-center">
      <img src="@/assets/images/info.svg" class="d-inline-block mr-3" alt="Information" />
      <p class="text-center mb-0 d-inline-block">
        Unable to Change Location. Please Remove Items From Your Cart.
      </p>
    </b-modal>
    <b-modal id="map" ref="map" centered hide-header :dialog-class="{ 'p-0 m-0': isMobile }" :content-class="{
      'border-0 rounded-0 mobile-map-height mobile-map-width': isMobile
    }" :body-class="{ 'mobile-map-width': isMobile }" :footer-class="{
      'border-top-0 position-fixed w-100 pin-location-mobile-footer': isMobile
    }" :modal-class="{ 'p-0 m-0 overflow-hidden': isMobile }" @show="onMapShow">
      <div id="pin-exact-location" :class="[
        'pb-2',
        { 'd-flex flex-row-reverse align-items-center': isMobile }
      ]">
        <h1 :class="['text-center', { 'flex-grow-1': isMobile }]">
          Pin Exact Location
        </h1>
        <img src="@/assets/images/close.svg" @click="closeMap()" :style="[
          {
            top: isMobile ? 'initial' : '12px',
            right: isMobile ? 'initial' : '8px'
          }
        ]" class="cursor-pointer" :class="{ 'position-relative mb-2 ml-2': isMobile }" alt="Close" />
      </div>
      <div id="pin-exact-location-autocomplete" class="px-2">
        <b-row no-gutters>
          <b-col cols="1">
            <img src="@/assets/images/pin-fill-red.svg" class="d-block mx-auto" style="position: relative; top: 4px;"
              alt="Red Pin" />
          </b-col>
          <b-col class="position-relative px-1">
            <gmap-autocomplete placeholder="Your Address" @place_changed="setPlaceModal" class="form-control" :options="{
              componentRestrictions: { country: 'ph' }
            }" ref="addressModal"></gmap-autocomplete>
            <img v-if="selectedLocationOnMap" @click.self="clearAddressOnMap" src="@/assets/images/remove-filled.svg"
              class="cursor-pointer position-absolute" style="top: 10px; right: 12px;" alt="Clear" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="link" @click="getCurrentPosition(true, false)" class="fw-bold px-0"
              style="font-size: 14px; color: #2F3941; text-decoration: underline; margin-left: 18px;">
              Use Current Location
            </b-button>
          </b-col>
        </b-row>
      </div>
      <GmapMap :center="formattedLatLng" :zoom="selectedLocationOnMap ? 15 : 5" :style="[
        'width: 100%;',
        { height: isMobile ? 'calc(100vh - 17px)' : '45vh' }
      ]" :options="{
        zoomControl: !isMobile,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: false
      }">
        <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true"
          :draggable="true" @click="center = m.position" @dragend="updateCoordinates" />
      </GmapMap>
      <template v-slot:modal-footer>
        <b-button size="lg" class="mx-auto find-store text-uppercase" variant="primary" @click="findStore"
          :disabled="branchesIsLoading" v-if="webDesign !== null && webDesign.design !== null" :style="{
            backgroundColor: webDesign.design.main_color + '!important',
            border: 'none !important',
            color: webDesign.design.button_text_color + '!important'
          }">
          Find Store
        </b-button>
        <b-button size="lg" class="mx-auto find-store text-uppercase" variant="primary" @click="findStore"
          :disabled="branchesIsLoading" v-else>
          Find Store
        </b-button>
      </template>
    </b-modal>
    <CartPromptModal />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";
import Cart from "@/components/cart/Cart";
import NavBrand from "@/components/layout/NavBrand";
import CartPromptModal from "@/components/cart/CartPromptModal";
import _ from "lodash";
import ProfileIcon from "@/components/customer/ProfileIcon";

function cartMiniDisplay(isCartToggled) {
  if (window.innerWidth < 845 && isCartToggled) {
    document.body.style.overflowY = "hidden";
  } else {
    document.body.style.overflowY = null;
  }
}

export default {
  name: "Navbar",
  components: {
    Cart,
    NavBrand,
    CartPromptModal,
    ProfileIcon,
  },
  data() {
    return {
      searchToggle: false,
      cartToggle: false,
      selectedPlace: "",
      showLocations: false,
      isConfirmRemove: false,
      place: null,
      formattedLatLng: null,
      latLng: null,
      markers: [],
      pinnedCoordinates: null,
      findStoreIsClicked: false,
      isMobileNaviconOpen: false,
      hasAutocompleteResults: false,
      selectedLocationOnMap: "",
      removeAllModal: false
    };
  },
  watch: {
    google: function () {
      this.getCurrentPosition();
    },
    cart: function () {
      if (this.cart && this.cart.cart_count >= 1) {
        this.showLocations = false;
      }

      if (this.cart) {
        const { message } = this.cart;

        if (
          message.includes("removed from cart") ||
          (this.$route.name === "Checkout" &&
            message.includes("logistic type is not available"))
        ) {
          if (!message.includes("retrieved cart")) {
            this.$root.$emit("bv::show::modal", "cart-prompt-modal");
          }
        }
      }
    },
    branchesIsLoading: function () {
      if (!this.branchesIsLoading && this.findStoreIsClicked) {
        this.closeMap();
        this.findStoreIsClicked = false;
      }
    },
    isMobileNaviconOpen(open) {
      if (open) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = null;
      }
    },
    cartToggle() {
      if (this.isMobileNaviconOpen) {
        this.$refs.mobileNavIcon.click();
      }
      this.$nextTick(() => {
        if (this.loggedIn) {
          cartMiniDisplay(this.cartToggle);
        }
      });

      if (!this.cartToggle) {
        this.removeAllModal = false;
      }
    },
    "$route"(currentRoute) {
      this.$nextTick(() => {
        if (this.isMobileNaviconOpen) {
          this.isMobileNaviconOpen = false;
        }
      });

      if (["Cart", "Checkout"].includes(currentRoute.name))
        this.viewCart();
    },
    coordinates(coordinates) {
      if (coordinates && !this.cart) this.viewCart();
    }
  },
  mounted() {
    this.$root.$on("openMap", () => {
      this.openMap();
    });
    this.$root.$on("redeemBalanceRefresh", () => {
      this.getCustomerBalance();
    });
    // Set Navbar "Search Place" from location null to selected place from in page map
    this.$root.$on("inPageMapSetSelectedPlace", place => {
      this.selectedPlace = place;
      this.$refs.address.$refs.input.value = place;

    });
    // Set Navbar Icon on Sidebar Trigger
    this.$root.$on("bv::toggle::collapse", el => {
      if (el === "mobile-menu-sidebar") {
        this.isMobileNaviconOpen = !this.isMobileNaviconOpen;
      }
    });
    this.$root.$on("mobilePlaceSelected", () => {
      this.$refs.mobileNavIcon.click();
    });
    this.$root.$on("toggleMobileNavIcon", route => {
      this.cartToggle = false;
      const path = this.$route.path.split("/").pop();
      const isSamePage =
        path !== route
          ? (route === "orders" && path === "upcoming") ||
          (route === "" && path === "estore")
          : path === route;
      if (!isSamePage) {
        this.isMobileNaviconOpen = !this.isMobileNaviconOpen;
      } else {
        this.$refs.mobileNavIcon.click();
      }
    });
    this.$root.$on("changeLocationNotAllowed", () => {
      this.$refs.location.show();
    });
    this.$root.$on("toggleCartIfOpened", () => {
      this.cartToggle = false;
    });
    window.addEventListener("resize", () => {
      // close mobile menu sidebar if not Mobile Size
      if (
        !this.isMobile &&
        this.isMobileNaviconOpen &&
        this.$refs.mobileNavIcon !== undefined
      ) {
        this.$refs.mobileNavIcon.click();
      }
      cartMiniDisplay(this.cartToggle);
    });
    this.$root.$on('refreshNavValues', (itemsToRefresh) => {
      itemsToRefresh.map(item => {
        this[item]();
      });
    });
    this.$root.$on('updateCart', () => {
      this.viewCart();
    });
  },
  beforeDestroy() {
    this.$root.$off("openMap");
    this.$root.$off("redeemBalanceRefresh");
    this.$root.$off("inPageMapSetSelectedPlace");
    document.body.style.overflowY = null;
    this.$root.$off("toggleMobileNavIcon");
    this.$root.$off("changeLocationNotAllowed");
    this.$root.$off("toggleCartIfOpened");
    this.$root.$off('refreshNavValues');
    this.$root.$off('updateCart');
  },
  created() {
    this.viewCart();

    if (this.token && this.customerPortalToken) {
      this.getCustomerBalance();
    }
    if (this.subdomain !== "ucoin" && this.subdomain != "bau-points") {
      this.getCurrentPosition();
    }
    // close mobile menu sidebar if not Mobile Size
    this.$nextTick(() => {
      if (!this.isMobile && this.isMobileNaviconOpen) {
        this.$refs.mobileNavIcon.click();
      }
    });

    this.onLocationAutocomplete = _.debounce(() => {
      const results = document.getElementsByClassName("pac-item")[0];

      if (results && this.$refs.address.$refs.input.value)
        this.hasAutocompleteResults = true;
      else this.hasAutocompleteResults = false;
    }, 300);
  },
  computed: {
    ...mapState("merchant", {
      merchantIsLoading: state => state.loading,
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapState("auth", {
      token: state => state.token,
      authIsLoading: state => state.loading,
      user: state => state.user
    }),
    ...mapState("estore", {
      cart: state => state.cart,
      estoreIsLoadingOverlay: state => state.loadingOverlay,
      estoreIsLoading: state => state.loading,
      estoreErrors: state => state.errors,
      webDesign: state => state.webDesign
    }),
    ...mapState("customer", {
      customer: state => state.user,
      location: state => state.location,
      customerErrors: state => state.errors,
      customerIsLoading: state => state.loading
    }),
    ...mapState("branch", {
      branchCoordinates: state => state.coordinates,
      branchesErrors: state => state.errors,
      branchesIsLoading: state => state.loading,
      coordinates: state => state.coordinates
    }),
    ...mapState("point", {
      balance: state => state.balance,
      pointIsLoading: state => state.loading,
      pointErrors: state => state.errors
    }),
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      isEstoreTopUp: "merchant/isEstoreTopUp",
      isPointsView: "merchant/isPointsView",
      cartUuid: "estore/cartUuid",
      isMobile: "isMobile/isMobile"
    }),
    google: gmapApi
  },
  methods: {
    onMapShow() {
      this.$nextTick(() => {
        this.selectedLocationOnMap = this.location;
        this.$refs.addressModal.$refs.input.value = this.location;
      });
    },
    setPlace(place) {
      this.selectedPlace = place.formatted_address;

      let coordinates = {};
      if (this.subdomain == "dunkin-donuts") {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 3
        };
      } else if (this.subdomain == "secretkitchen") {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 40
        };
      } else if (
        this.subdomain == "bistrobff" ||
        this.subdomain == "cafe-france" ||
        this.subdomain == "estore"
      ) {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 5
        };
      } else if (this.subdomain == "wildflour") {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 28
        };
      } else if (this.subdomain == "generika") {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 7
        };
      } else {
        coordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 8
        };
      }

      const marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      this.markers.push({ position: marker });

      this.$store.commit("branch/SET_COORDINATES", coordinates);
      this.$store.commit("customer/SET_LOCATION", place.formatted_address);

      this.showLocations = !this.showLocations;
      if (this.showLocations) {
        this.showLocations = !this.showLocations;
      }
    },
    setPlaceModal(place) {
      this.selectedLocationOnMap = place.formatted_address;

      if (this.subdomain == "dunkin-donuts") {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 3
        };
      } else if (this.subdomain == "secretkitchen") {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 40
        };
      } else if (
        this.subdomain == "bistrobff" ||
        this.subdomain == "cafe-france" ||
        this.subdomain == "estore"
      ) {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 5
        };
      } else if (this.subdomain == "wildflour") {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 28
        };
      } else if (this.subdomain == "generika") {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 7
        };
      } else {
        this.pinnedCoordinates = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng(),
          distance: 8
        };
      }

      const formattedLatLng = new this.google.maps.LatLng(
        parseFloat(place.geometry.location.lat()),
        parseFloat(place.geometry.location.lng())
      );

      this.formattedLatLng = formattedLatLng;

      this.markers = [];

      const marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      this.markers.push({ position: marker });
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        if (this.$route.name != "Home") {
          this.$router.push({ path: "/" + this.subdomain });
        }
      });
    },
    toggleLocations() {
      if (this.cart == null || this.cart.cart_count == 0) {
        this.showLocations = !this.showLocations;
      } else {
        this.$refs["location"].show();
      }
    },
    getCurrentPosition(fromButton = false, willUpdateLocation = true) {
      // On First Load If There's No Location, Get the Current Position
      if (this.location == null || fromButton) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            position => {
              if (this.google != null) {
                const formattedLatLng = new this.google.maps.LatLng(
                  parseFloat(position.coords.latitude),
                  parseFloat(position.coords.longitude)
                );

                this.formattedLatLng = formattedLatLng;

                if (this.subdomain == "dunkin-donuts") {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 3
                  };
                } else if (this.subdomain == "secretkitchen") {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 40
                  };
                } else if (
                  this.subdomain == "bistrobff" ||
                  this.subdomain == "cafe-france" ||
                  this.subdomain == "estore"
                ) {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 5
                  };
                } else if (this.subdomain == "wildflour") {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 28
                  };
                } else if (this.subdomain == "generika") {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 7
                  };
                } else {
                  this.pinnedCoordinates = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    distance: 8
                  };
                }

                this.markers = [];

                const marker = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                };

                this.markers.push({ position: marker });

                let geocoder = new this.google.maps.Geocoder();
                geocoder.geocode(
                  { latLng: formattedLatLng },
                  (result, status) => {
                    if (status === this.google.maps.GeocoderStatus.OK) {
                      const formattedAddress = result[0].formatted_address;

                      if (this.$refs.addressModal) {
                        this.$refs.addressModal.$refs.input.value = formattedAddress;
                        this.selectedLocationOnMap = formattedAddress;
                      }

                      if (willUpdateLocation) {
                        this.selectedPlace = formattedAddress

                        if (this.$refs.address)
                          this.$refs.address.$refs.input.value = formattedAddress;

                        this.$store.commit(
                          "customer/SET_LOCATION",
                          formattedAddress
                        );
                        this.$store.commit(
                          "branch/SET_COORDINATES",
                          this.pinnedCoordinates
                        );
                      }

                      if (this.showLocations)
                        this.showLocations = !this.showLocations;
                    }
                  }
                );
              }
            },
            () => {
              this.handleLocationError(true);
            }
          );
        } else {
          // Browser doesn't support Geolocation
          this.handleLocationError(false);
        }
      } else {
        this.selectedPlace = this.location;
        if (this.$refs.address != undefined) {
          this.$refs.address.$refs.input.value = this.location;
        }
      }
    },
    async viewCart() {
      if (
        this.customerPortalToken &&
        !_.isEmpty(this.coordinates) &&
        (this.token || this.cartUuid)
      ) {
        this.isBranchDetailsDataLoaded = false;
        const header = {
          "X-Merchant-Token": this.customerPortalToken
        };
        const payload = {
          customer_lat: this.coordinates.lat,
          customer_lng: this.coordinates.long,
        }

        if (this.token)
          header["Authorization"] = this.token;

        if (this.cartUuid && !this.token)
          payload.cart_uuid = this.cartUuid;

        const request = {
          header,
          payload,
        };

        await this.$store.dispatch("estore/viewCart", request);
      }
    },
    handleLocationError(browserHasGeolocation) {
      if (browserHasGeolocation) {
        console.log("Error: The Geolocation service failed.");
      } else {
        console.log("Error: Your browser doesn't support geolocation.");
      }
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.cartToggle = !this.cartToggle;
    },
    updateCoordinates(location) {
      if (this.subdomain == "dunkin-donuts") {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 3
        };
      } else if (this.subdomain == "secretkitchen") {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 40
        };
      } else if (
        this.subdomain == "bistrobff" ||
        this.subdomain == "cafe-france" ||
        this.subdomain == "estore"
      ) {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 5
        };
      } else if (this.subdomain == "wildflour") {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 28
        };
      } else if (this.subdomain == "generika") {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 7
        };
      } else {
        this.pinnedCoordinates = {
          lat: location.latLng.lat(),
          long: location.latLng.lng(),
          distance: 8
        };
      }

      const formattedLatLng = new this.google.maps.LatLng(
        parseFloat(location.latLng.lat()),
        parseFloat(location.latLng.lng())
      );

      let geocoder = new this.google.maps.Geocoder();
      geocoder.geocode({ latLng: formattedLatLng }, (result, status) => {
        if (status === this.google.maps.GeocoderStatus.OK) {
          this.$refs.addressModal.$refs.input.value =
            result[0].formatted_address;
          this.selectedLocationOnMap = result[0].formatted_address;
        }
      });
    },
    openMap() {
      // DEFAULTS TO KILOMETER ZERO MARKER IN MANILA
      let latitude = 14.5813;
      let longitude = 120.9762;

      if (this.branchCoordinates) {
        latitude = this.branchCoordinates.lat;
        longitude = this.branchCoordinates.long;
      }

      // When Browser Is Refreshed, Assign Current Coordinates to formattedLatLng to Be Used on Google Maps When Centering It
      const formattedLatLng = new this.google.maps.LatLng(
        parseFloat(latitude),
        parseFloat(longitude)
      );
      this.formattedLatLng = formattedLatLng;

      // For Marker on Pinned Location
      this.markers = [];

      const marker = {
        lat: latitude,
        lng: longitude
      };

      this.markers.push({ position: marker });

      this.$refs["map"].show();
    },
    closeMap() {
      this.$refs["map"].hide();
    },
    findStore() {
      this.$store.commit("branch/SET_COORDINATES", this.pinnedCoordinates);
      this.findStoreIsClicked = true;
      this.selectedPlace = this.selectedLocationOnMap;
      this.$refs.address.$refs.input.value = this.selectedLocationOnMap;
      this.$store.commit("customer/SET_LOCATION", this.selectedLocationOnMap);
      this.$refs["map"].hide();
    },
    async getCustomerBalance() {
      if (this.loggedIn && this.customerPortalToken) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken
          }
        };
        await this.$store.dispatch("point/getCustomerBalance", request);
      }
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleCartMobile() {
      if (this.isMobileNaviconOpen) this.$refs.mobileNavIcon.click();

      if (this.loggedIn || this.cartUuid)
        this.$router.push({ name: "Cart" });
    },
    clearAddress() {
      this.$store.commit("customer/resetLocation");
      this.$store.commit("branch/resetCoordinates");
      localStorage.removeItem("location");
      localStorage.removeItem("coordinates");
      this.$root.$emit('inPageMapSetSelectedPlace', "");
      this.$refs.address.$refs.input.value = "";
      this.$nextTick(() => {
        this.$refs.address.$refs.input.focus();
      });
    },
    clearAddressOnMap() {
      this.selectedLocationOnMap = "";
      this.$refs.addressModal.$refs.input.value = "";
      this.$nextTick(() => {
        this.$refs.addressModal.$refs.input.focus();
      });
    },
    onClickMobileLocation() {
      if (this.cart && this.cart.cart_count) this.$refs.location.show();
      else this.openMap();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../../assets/styles/components/layout/navbar.scss";
@import "./../../assets/styles/components/layout/mobile-nav.scss";

#selectMap {
  a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

.points-container {
  height: 40px;
  border: 1px solid #d8dcde;
  border-radius: 38px;
  display: flex;

  .balance-container {
    color: #87929D;
    flex: 1;
    padding: 5px 10px;

    .fw-bold {
      color: #2F3941;
    }
  }
}

#navbar-top-container {
  width: calc(100% - 1px) !important;
  position: sticky;
  top: 0;
  z-index: 8;
}

.branch-count {
  font-size: 15px !important;
}

.clear-cart {
  padding: 3px !important;
  background-color: transparent !important;
  border-radius: 31px !important;
  min-width: 85px;
  font-size: 12px;
}

.remove-all-modal {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  width: 180px;
  text-align: center;
  padding: 15px 20px;
  z-index: 2;
  position: absolute;
  right: 10px;
  bottom: -120px;

  label {
    text-align: center;
    font-style: normal;
    font-size: 16px;
    color: #2f3941;
  }

  ul {
    margin: 10px 0px;
    list-style: none;
    padding: 0px;

    li {
      width: 50%;
      display: inline-block;
      font-style: normal;
      font-size: 18px;

      cursor: pointer;

      &:last-child {
        color: $orange;
      }
    }
  }
}
</style>

<style lang="scss">
.mobile-map-width {
  width: 100vw !important;
}

.mobile-map-height {
  height: calc(100vh - 15px) !important;
}

.pin-location-mobile-footer {
  bottom: 0;
}
</style>
